<!-- @format -->
<ng-container id="pdp-pro-tips">
	@if (isBrowser) {
		<h3 class="hmf-display-flex hmf-justify-content-center">
			<img
				class="hmf-m-xs"
				[src]="headerSvg"
				[alt]="altSvgText"
				draggable="false"
				loading="lazy" />
			<span [hidden]="true">Dick's Pro Tips</span>
		</h3>
		<hmf-carousel
			[showHeader]="false"
			[showTitle]="false"
			[showSubtitle]="false"
			[showActionButton]="false">
			@for (article of articleData; track article.id) {
				<article
					class="pro-tips-card hmf-w-100"
					[class]="{ 'hmf-mr-s': $index !== articleData.length - 1 }">
					<a
						[href]="article.url"
						target="_blank">
						<div class="pro-tips-card__image">
							<img
								class="hmf-w-100 hmf-h-100"
								[src]="article.image"
								[alt]="article.title"
								loading="lazy" />
						</div>
						<div
							class="pro-tips-card__content hmf-display-flex hmf-flex-column hmf-p-s hms-h-100">
							<h2 class="hmf-header-bold-s hmf-mb-xxs hms-position-relative">
								{{ article.title }}
							</h2>
							<p class="summary hmf-header-xs hmf-mt-0">
								{{ article.description }}
							</p>
						</div>
					</a>
				</article>
			}
		</hmf-carousel>
	}
</ng-container>
